import { Box } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Link } from 'react-router-dom'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import OrderStatus from '../../../../../components/customElements/RequestDataAccordions/OrderStatus'
import OrderInfoChips from '../../../../../components/OrderInfoChips/OrderInfoChips'
import commonStyles from '../../../../../styles/commonStyles'
import { getStyles } from '../../../../../utils/utils/commonUtils'
import { getComp } from '../../../../../utils/utils/DI'
import { RequestType } from '../../SingleRequest/types/Request.type'

interface StatusAndDuplicateUnitProps {
  request: RequestType
}

const StatusAndDuplicateUnit: React.FC<StatusAndDuplicateUnitProps> = ({
  request,
}) => {
  const classes = getStyles(commonStyles)
  return (
    <>
      <Box sx={classes.drawerStatusesInfo}>
        <OrderStatus
          status={request.status}
          onEdit={false}
          report={null}
          isService={false}
          styleEdit={null}
        />
        {Number(request.status) >= 12 && (
          <Link target='_blank' to={`/reports/${request.reportId}`}>
            <OrderInfoChips
              tooltip={getComp('StatusesStore').getStatusName(
                request.reportStatus,
                true,
              )}
              propsStyle={null}
              pointer
              preventClick
              id={request.reportId} // id отчета
              reportStatus={request.reportStatus} // статус отчета
              haveChips={true} // регулирует наличие фона по типу чипса
              showOrderStatusIcon={true} // регулирует отображение иконки статуса
            />
          </Link>
        )}
      </Box>
      {request.hasDuplicates && (
        <Box
          className={'fx-center'}
          sx={{
            padding: '8px 16px 16px',
            width: '100%',
          }}
        >
          <DataUnit value={'Отмечена как повторная заявка'} />
        </Box>
      )}
    </>
  )
}

export default observer(StatusAndDuplicateUnit)
